/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('RecipientsDetailsGroup', function($scope, $rootScope, $stateParams, recipientgroupService,
    recipientService, _$editmode, _$privileges, $mdDialog) {

    _$editmode.turnOff();

    $scope.id = $stateParams.id;

    $scope.list = {};

    $scope.row = {
        'group_name': '',
        'description': '',
        'active': 0,
        'filter': {
            'sex': '',
            'name': '',
            'surname': '',
            'street': '',
            'postcode': '',
            'comunity': '',
            'city': '',
            'age': '',
            'age_before': '',
            'age_after': ''
        }
    };

    $scope.data = {
        "age_before": "",
        "age_after": "",
        "copy_group_name": "",
        "city": "",
        "comunity": "",
        "can_write": _$privileges.write("message"),
        "user_id": "",
        "activeNotifications": []
    };

    $scope.tab = {
        "title": "Szczegóły grupy odbiorców",
        "type": "add",
        "editable": false,
        "selected": 0,
        "change": function(kind) {
            $scope.tab.selected = kind == 'next' ? $scope.tab.selected + 1 : $scope.tab.selected - 1;
        }
    };

    $scope.autocompletes = {
        "county": [],
        "city": [],
        "comunity": [],
        "street": []
    };

    $scope.init = function() {
        var promise = $scope.id ? recipientgroupService.show($scope.id) : recipientgroupService.create();
        promise.then(
            function(payload) {
                $scope.data.activeNotifications = payload.data.activeNotifications;
                if (payload.data.row.length == 0) {
                    $rootScope.notification.showAfterRedirect('message_rcgroup', {}, 'error', 'Podana grupa odbiorców nie została odnaleziona');
                } else {
                    $scope.row = payload.data.row;
                    $scope.data.user_id = payload.data.user_id;

                    var county = $scope.row.filter.county;
                    if (county) {
                        county = county.split(",");
                        for (var i = 0; i < county.length; i++) {
                            if (county[i] != "") {
                                $scope.autocompletes.county.push({
                                    name: county[i],
                                    readonly: true
                                });
                            }
                        }
                    }

                    var comunity = $scope.row.filter.comunity;
                    if (comunity) {
                        comunity = comunity.split(",");
                        for (var i = 0; i < comunity.length; i++) {
                            if (comunity[i] != "") {
                                $scope.autocompletes.comunity.push({
                                    name: comunity[i],
                                    readonly: true
                                });
                            }
                        }
                    }

                    var city = $scope.row.filter.city;
                    if (city) {
                        city = city.split(",");
                        for (var i = 0; i < city.length; i++) {
                            if (city[i] != "") {
                                $scope.autocompletes.city.push({
                                    name: city[i],
                                    readonly: true
                                });
                            }
                        }
                    }

                    var street = $scope.row.filter.street;
                    if (street) {
                        street = street.split(",");
                        for (var i = 0; i < street.length; i++) {
                            if (street[i] != "") {
                                $scope.autocompletes.street.push({
                                    name: street[i],
                                    readonly: true
                                });
                            }
                        }
                    }
                }

                $rootScope.filters = payload.data.filters;
                $scope.list = payload.data.list;
                if (typeof $scope.row != "undefined" && $scope.row.filter.age != null && $scope.row.filter.age != "") {
                    var age = $scope.row.filter.age.split("_");
                    if (age[0] == "date") {
                        $scope.row.filter.age_before = new Date($scope.row.filter.age_before);
                        if ($scope.row.filter.age_after != "")
                            $scope.row.filter.age_before = new Date($scope.row.filter.age_before);
                    } else {
                        $scope.row.filter.age_before = parseInt($scope.row.filter.age_before, 10);
                        if ($scope.row.filter.age_after != "")
                            $scope.row.filter.age_after = parseInt($scope.row.filter.age_after, 10);
                    }
                }
            },
            function(errorPayload) {
                $rootScope.notification.showAfterRedirect('message_rcgroup', {}, 'error', 'Błąd wyświetlania listy odbiorców');
            });
    };

    $scope.init();

    $scope.delete = function() {
        var promise = recipientgroupService.delete($scope.id);
        promise.then(
            function(payload) {
                if (payload.data.code) {
                    $rootScope.notification.showAfterRedirect('message_rcgroup', {}, 'success', payload.data.msg);
                } else {
                    $rootScope.notification.show('error', payload.data.msg);
                }
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Wystąpił błąd podczas próby usunięcia grupy odbiorców');
            });
    };

    $scope.panel = {
        "copy": {
            "name": "",
            "show": function() {
                var parentEl = angular.element(document.body);
                $mdDialog.show({
                    parent: parentEl,
                    controller: function() {
                        this.parent = $scope;
                    },
                    controllerAs: 'ctrl',
                    templateUrl: "/assets/js/angular/recipients/views/modal/group_copy.html?v=2"
                });
            },
            "commit": function() {
                var promise = recipientgroupService.copy({
                    "id": $scope.id,
                    "name": $scope.panel.copy.name
                });
                promise.then(
                    function(payload) {
                        $rootScope.notification.show(payload.data.code ? 'success' : 'error', payload.data.msg);
                        $scope.panel.copy.name = "";
                    });
                $mdDialog.hide();
            },
            "cancel": function() {
                $mdDialog.cancel();
            }
        }
    };
});
